/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { AdminService } from '../../services/admin.service';
import { MarketoService } from '../../services/marketo.service';
import { PardotService } from '../../services/pardot.service';
import { HubspotService } from '../../services/hubspot.service';
import { EloquaService } from '../../services/eloqua.service';
import { SessionService } from '../../services/session2.service';

@Component({
  selector: 'app-admin-map',
  templateUrl: './admin-map.component.html'
})
export class AdminMapComponent implements OnInit {
  session: any = {};
  tab: string = 'email';
  accounts: any[] = [];
  selectedAccount: any[];
  selectedIntegration: string;
  fields: any[] = [];
  nullFields: any[] = [];

  // state management
  loading: any = {
    any: false,
    accounts: false,
    contact: false
  };

  pageState: any = {
    emailAddress: '',
    contactFound: false,
    searchRun: false,
    showNullFields: false
  };

  accountDDSettings: any = {
    text: 'Account',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  constructor(private cacheService: CacheService,
              private adminService: AdminService,
              private marketoService: MarketoService,
              private pardotService: PardotService,
              private hubspotService: HubspotService,
              private eloquaService: EloquaService,
              private sessionService: SessionService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  changeAccount() {
    this.selectedIntegration = this.selectedAccount[0].integration;
  }

  searchEmail() {
    this.loading.contact = true;
    this.fields = [];
    this.nullFields = [];
    this.pageState.searchRun = true;
    switch (this.selectedIntegration) {
      case 'Marketo':
        this.marketoSearch();
        break;
      case 'Eloqua':
        this.eloquaSearch();
        break;
      case 'HubSpot':
        this.hubspotSearch();
        break;
      case 'Pardot':
        this.pardotSearch();
        break;
    }
  }

  clearResults() {
    this.fields = [];
    this.nullFields = [];
    this.pageState.contactFound = false;
    this.pageState.searchRun = false;
    this.pageState.showNullFields = false;
  }

  initView() {
    this.loading.accounts = true;
    this.loading.any = true;
    this.adminService.getAccounts().subscribe((result: any) => {
      result.forEach((a) => {
        let integration: string = 'None';
        if (a.integration.marketo) {
          integration = 'Marketo';
        }
        if (a.integration.eloqua) {
          integration = 'Eloqua';
        }
        if (a.integration.hubspot) {
          integration = 'HubSpot';
        }
        if (a.integration.pardot) {
          integration = 'Pardot';
        }
        this.accounts.push({ id: a._id, itemName: a.name, integration: integration });
      });

      this.accounts.sort((a, b) => {
        if (a.itemName.toLowerCase() > b.itemName.toLowerCase()) {
          return 1;
        }
        else {
          return -1;
        }
      });

      this.loading.accounts = false;
      this.loading.any = false;
      // TEMP for dev
      // this.selectedAccount = [this.accounts.find(a=> { return a.itemName == 'Siftrock Demo'})];
      // this.changeAccount();
    });
  }

  private marketoSearch() {
    this.marketoService.searchEmail(this.selectedAccount[0].id, this.pageState.emailAddress).subscribe((result: any) => {
      if (result.length > 0) {
        for (let key in result[0]) {
          if (result[0][key]) {
            this.fields.push({name: key, value: result[0][key]});
          }
          else {
            this.nullFields.push({name: key, value: '[empty]'});
          }
        }
        this.pageState.contactFound = true;
      }
      else {
        this.pageState.contactFound = false;
      }
      this.loading.contact = false;
    });
  }

  private eloquaSearch() {
    this.eloquaService.searchEmail(this.selectedAccount[0].id, this.pageState.emailAddress).subscribe((result: any) => {
      if (result.length > 0) {
        for (let key in result[0]) {
          if (result[0][key]) {
            this.fields.push({name: key, value: result[0][key]});
          }
          else {
            this.nullFields.push({name: key, value: '[empty]'});
          }
        }
        this.pageState.contactFound = true;
      }
      else {
        this.pageState.contactFound = false;
      }
      this.loading.contact = false;
    });
  }

  private hubspotSearch() {
    this.hubspotService.searchEmail(this.selectedAccount[0].id, this.pageState.emailAddress).subscribe((result: any) => {
      if (result.length > 0) {
        for (let key in result[0]) {
          if (result[0][key]) {
            this.fields.push({name: key, value: result[0][key]});
          }
          else {
            this.nullFields.push({name: key, value: '[empty]'});
          }
        }
        this.pageState.contactFound = true;
      }
      else {
        this.pageState.contactFound = false;
      }
      this.loading.contact = false;
    });
  }

  private pardotSearch() {
    this.pardotService.searchEmail(this.selectedAccount[0].id, this.pageState.emailAddress).subscribe((result: any) => {
      if (result.length > 0) {
        for (let key in result[0]) {
          if (result[0][key]) {
            this.fields.push({name: key, value: result[0][key]});
          }
          else {
            this.nullFields.push({name: key, value: '[empty]'});
          }
        }
        this.pageState.contactFound = true;
      }
      else {
        this.pageState.contactFound = false;
      }
      this.loading.contact = false;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-map/admin-map.component.ts